import { render, staticRenderFns } from "./card-claim-overview.vue?vue&type=template&id=79aae36f&"
import script from "./card-claim-overview.vue?vue&type=script&lang=js&"
export * from "./card-claim-overview.vue?vue&type=script&lang=js&"
import style0 from "./card-claim-overview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports